import React from 'react';
import Button from '@mui/material/Button';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import styles from './SeriesButton.module.scss';

export function SeriesButton() {
  const intl = useIntl();
  return (
    <Button
      component={Link}
      to="/ha-overview"
      className={styles.seriesButton}
      variant="contained"
      color="primary"
      aria-label={intl.formatMessage({ id: 'calendar.series.button', defaultMessage: 'Series' })}
    >
      <EventRepeatIcon sx={{ width: 16, height: 16 }} />
    </Button>
  );
}
